module.exports = __webpack_public_path__ + "img/Dinotastisch.d9a4daf7.jpg";